// The rosa is searched by name; the API answers its fuoriquota (`over_age`).

import type { ClubPlayerRead } from '@volee/api-client'

import { personName } from './labels.ts'

/** Case- and accent-insensitive, because a roster is searched by a name typed in a hurry. */
export function matchesName(player: ClubPlayerRead, query: string): boolean {
  if (query.trim() === '') return true
  return fold(playerName(player)).includes(fold(query))
}

/** Cognome first, as every list of people in the product reads. Keeps its domain name for
 *  the roster's callers and delegates, so the spelling lives in one place. */
export function playerName(player: ClubPlayerRead): string {
  return personName(player)
}

function fold(text: string): string {
  return text
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .toLowerCase()
}
